<template>
    <div class="components-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-input v-model="queryForm.zydm" placeholder="专业代码 / 名称" style="width:180px;"></el-input>
            <!-- <el-input v-model="queryForm.zymc" placeholder="专业名称" style="width:180px;"></el-input> -->
            <el-select v-model="queryForm.zsxz" placeholder="招生性质" style="width:180px;" clearable>
                <el-option v-for="(item, index) in comboOption.property" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.xbdm" placeholder="所属部系" style="width:180px;" clearable>
                <el-option v-for="(item, index) in comboOption.dept" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.gbzydm" placeholder="国标专业代码 / 名称" style="width:180px;"></el-input>
            <!-- <el-input v-model="queryForm.gbzymc" placeholder="国标专业名称" style="width:180px;"></el-input> -->

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;新建</el-button>
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{(queryForm.pageNum - 1) * queryForm.rowNum + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="专业代码" prop="zydm" width="120px" align="center"></el-table-column>
            <el-table-column label="专业名称" prop="zymc" align="center"></el-table-column>
            <el-table-column label="招生性质" prop="zsxzmc" width="120px" align="center"></el-table-column>
            <el-table-column label="所属系部" prop="xbmc" align="center"></el-table-column>
            <el-table-column label="学制" prop="xz" width="80px" align="center"></el-table-column>
            <el-table-column label="国标专业代码" prop="gbzydm" width="120px" align="center"></el-table-column>
            <el-table-column label="国标专业名称" prop="gbzymc" align="center"></el-table-column>
            <el-table-column label="专业负责人" prop="zyzzxm" width="150px" align="center"></el-table-column>
            <el-table-column label="操作" width="180px" align="center">
                <template slot-scope="scope">
                    <el-button type="warning" size="small" @click="modRec(scope.row)">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                    <el-button type="danger" size="small" @click="delRec(scope.row)">
                        <i class="el-icon-delete"></i>&nbsp;删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页区域 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                :current-page.sync="queryForm.pageNum" :page-sizes="[10, 20, 50]" :page-size="queryForm.rowNum"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 表单区域 -->
        <el-dialog class="customElRow" :title="CurdDialogTitle" :visible.sync="CurdDialogVisible" @closed="closeCurdDialog" width="800px" top="150px">
            <el-form ref="curdForm" :model="curdForm" label-width="120px" label-position="left" :rules="CurdRules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="专业代码" prop="zydm">
                            <el-input v-model="curdForm.zydm" :disabled="true" placeholder="系统自动生成"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="专业名称" prop="zymc">
                            <el-input v-model="curdForm.zymc"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="所属系部" prop="xbdm">
                            <el-select v-model="curdForm.xbdm" placeholder="请选择" style="width:100%;" clearable :disabled="editFlag">
                                <el-option v-for="(item, index) in comboOption.dept" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="招生性质" prop="zsxz">
                            <el-select v-model="curdForm.zsxz" placeholder="请选择" style="width:100%;" clearable :disabled="editFlag">
                                <el-option v-for="(item, index) in comboOption.property" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学制" prop="xz">
                            <el-input-number v-model="curdForm.xz" style="width:100%;" :min="2" :max="5" :precision="1" :step="0.5" label="请输入学制"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="国标专业代码" prop="gbzydm">
                            <el-input v-model="curdForm.gbzydm"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="国标专业名称" prop="gbzymc">
                            <el-input v-model="curdForm.gbzymc"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="教育层次" prop="jycc">
                            <el-select v-model="curdForm.jycc" placeholder="请选择" style="width:100%;" clearable>
                                <el-option v-for="(item, index) in comboOption.level" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="专业负责人" prop="groupLeader">
                            <el-select v-model="curdForm.groupLeader" multiple placeholder="请选择" style="width:100%;" filterable clearable>
                                <el-option v-for="(item, index) in comboOption.leader" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" @click="save()">保存</el-button>
                <el-button @click="CurdDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            return {
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    zydm: null,
                    zymc: null,
                    zsxz: null,
                    xbdm: null,
                    gbzydm: null,
                    gbzymc: null,
                },
                //表单数据
                curdForm: {
                    id: null,
                    zydm: null,
                    zymc: null,
                    zsxz: null,
                    xbdm: null,
                    zyzzbh: null,
                    zyzzxm: null,
                    xz: undefined,
                    gbzydm: null,
                    gbzymc: null,
                    jycc: null,
                    groupLeader: [],
                },
                //下拉列表数据
                comboOption:{
                    leader: null,
                    dept: null,
                    property: null,
                    level: null,
                },
                editFlag: false,
                //表数据
                tableData: [],
                //默认页数
                total: null,
                CurdDialogTitle: "",
                CurdDialogVisible: false,
                //选中行的数据
                selectRowData: null,
                tableLoading: true,
                mainTableHeight: 500,
                CurdRules: {
                    zymc: [{
                            required: true,
                            message: "请填写专业名称",
                            trigger: "blur",
                        },
                        {
                            min: 1,
                            max: 50,
                            message: "专业名称超过50位",
                            trigger: "blur",
                        },
                    ],
                    gbzydm: [{
                            required: true,
                            message: "请填写国标专业代码",
                            trigger: "blur",
                        }
                    ],
                    gbzymc: [{
                            required: true,
                            message: "请填写国标专业名称",
                            trigger: "blur",
                        },
                        {
                            min: 1,
                            max: 50,
                            message: "专业名称超过50位",
                            trigger: "blur",
                        },
                    ],
                    zsxz: [{
                        required: true,
                        trigger: ['blur','change'],
                        message: "请选择招生性质",
                    }],
                    xbdm: [{
                        required: true,
                        trigger: ['blur','change'],
                        message: "请选择系部",
                    }],
                    xz: [{
                        required: true,
                        trigger: ['blur'],
                        message: "请填写学制",
                    }],
                },
            }
        },
        mounted() {
            this.queryList();
            this.initCombo();

            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            queryList() {
                this.tableLoading = true;
                this.$api.baseInfo.major.queryList({
                    data: this.queryForm,
                }).then((res) => {
                    this.total = res.data.data.total;
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((err) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            //获取专业组长下拉框数据
            initCombo() {
                this.$api.baseInfo.major.initCombo({}).then((res) => {
                    this.comboOption.leader = res.data.data.leader;
                    this.comboOption.dept = res.data.data.dept;
                    this.comboOption.property = res.data.data.property;
                    this.comboOption.level = res.data.data.level;
                }).catch((err) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            addRec(){
                this.CurdDialogTitle = "新建";
                this.CurdDialogVisible = true;
                this.editFlag = false;
            },
            modRec(rowData){
                this.selectRowData = rowData;
                this.CurdDialogTitle = "编辑";
                this.CurdDialogVisible = true;
                this.editFlag = true;

                this.$nextTick().then(() => {
                    this.curdForm.id = this.selectRowData.id;
                    this.curdForm.zydm = this.selectRowData.zydm;
                    this.curdForm.zymc = this.selectRowData.zymc;
                    this.curdForm.zsxz = this.selectRowData.zsxz;
                    this.curdForm.xbdm = this.selectRowData.xbdm;
                    this.curdForm.xz = this.selectRowData.xz;
                    this.curdForm.jycc = this.selectRowData.jycc;
                    this.curdForm.gbzydm = this.selectRowData.gbzydm;
                    this.curdForm.gbzymc = this.selectRowData.gbzymc;
                    this.curdForm.zyzzbh = this.selectRowData.zyzzbh;
                    this.curdForm.zyzzxm = this.selectRowData.zyzzxm;
                    if(this.selectRowData.zyzzbh && this.selectRowData.zyzzbh!=''){
                        this.curdForm.groupLeader = this.selectRowData.zyzzbh.split(",");
                    }
                });
            },
            delRec(rowData){
                this.selectRowData = rowData;

                confirmMsg('是否确定要删除当前选择的专业').then(() => {
                    this.$api.baseInfo.major.deleteById({
                        data: this.selectRowData,
                    }).then((res) => {
                        let state = res.data.data.State;
                        switch (state) {
                            case 'Succees':
                                this.CurdDialogVisible = false;
                                showNotify('成功', '删除成功', 'success', 1500);
                                this.queryList();
                                break;
                            case 'Exist':
                                this.$alert('当前选择的专业已经与班级关联，无法删除！', '提示', {
                                    confirmButtonText: '确定'
                                });
                                break;
                            default:
                                showNotify('错误', '删除失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        this.formSubmiting = false;
                        showNotify('错误', error, 'error', 3000);
                    });
                    this.selectRowData = null;
                });
            },
            save() {
                this.$refs['curdForm'].validate((valid) => {
                    if (valid) {
                        if(this.curdForm.groupLeader.length > 0){
                            let tempTeaName = [];
                            for(let i=0; i<this.curdForm.groupLeader.length; i++){
                                for(let j=0; j<this.comboOption.leader.length; j++){
                                    if(this.curdForm.groupLeader[i] == this.comboOption.leader[j].comboValue){
                                        tempTeaName.push(this.comboOption.leader[j].comboName);
                                        break;
                                    }
                                }
                            }
                            this.curdForm.zyzzxm = '@' + tempTeaName.join('@,@') + '@';
                            this.curdForm.zyzzbh = '@' + this.curdForm.groupLeader.join('@,@') + '@';
                        }else{
                            this.curdForm.zyzzxm = '';
                            this.curdForm.zyzzbh = '';
                        }

                        this.$api.baseInfo.major.save({
                            data: this.curdForm,
                        }).then((res) => {
                            let state = res.data.data.State;
                            switch (state) {
                                case 'Exist':
                                    this.$alert('当前填写的专业名称已存在', '提示', {
                                        confirmButtonText: '确定'
                                    });
                                    break;
                                case 'Succees':
                                    this.CurdDialogVisible = false;
                                    showNotify('成功', '保存成功', 'success', 1500);
                                    this.queryList();
                                    break;
                                default:
                                    showNotify('错误', '保存失败', 'error', 3000);
                                    break;
                            }
                        }).catch((err) => {
                            showNotify('错误', error, 'error', 3000);
                        });
                    } else {
                        return false;
                    }
                });
            },
            //关闭对话框
            closeCurdDialog() {
                this.CurdDialogVisible = false;

                if(this.$refs['curdForm'] !== undefined){
                    this.$refs['curdForm'].clearValidate();
                    this.$refs['curdForm'].resetFields();
                }
                this.curdForm.groupLeader = [];
                this.curdForm.id = null;
            },
            //页码区域方法
            handleCurrentChange(val, old) {
                this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.queryForm.rowNum = val;
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handleFilter() {
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handlePageChange(val) {
                this.queryForm.pageNum = val;
                this.queryList();
            },
            handleReset() {
                this.queryForm.pageNum = 1;
                this.queryForm.rowNum = 10;
                this.queryForm.zydm = null;
                this.queryForm.zymc = null;
                this.queryForm.zsxz = null;
                this.queryForm.xbdm = null;
                this.queryForm.gbzydm = null;
                this.queryForm.gbzymc = null;
                this.tableLoading = false;
                this.queryList();
            },
        }
    };
</script>
<style scoped>
    .customElRow .el-row {
        padding-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// major.vue?350308f4